/**
 * Reverbera — auto-select first available color when pot type changes.
 * When the variant-selects DOM is replaced by Dawn, if the previously
 * selected color is now visually-disabled, click the first available one.
 */
(function () {
  function autoSelectFirstAvailableColor(variantSelects) {
    var swatchFieldset = variantSelects.querySelector('.product-form__input--swatch');
    if (!swatchFieldset) return;

    var checked = swatchFieldset.querySelector('.swatch-input__input:checked');
    if (!checked || !checked.classList.contains('visually-disabled')) return;

    var first = swatchFieldset.querySelector('.swatch-input__input:not(.visually-disabled)');
    if (!first) return;

    first.checked = true;
    first.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function observe(productInfo) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].tagName === 'VARIANT-SELECTS') {
            autoSelectFirstAvailableColor(added[j]);
          }
        }
      }
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function fixPaymentButtonPadding() {
    document.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (btn) {
      btn.style.setProperty('padding-top', '4px', 'important');
      btn.style.setProperty('padding-bottom', '4px', 'important');
      btn.style.setProperty('min-height', '0', 'important');
    });
  }

  function observePaymentButton() {
    var timer;
    var root = document.querySelector('product-info') || document.body;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(fixPaymentButtonPadding, 80);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('product-info').forEach(observe);
    fixPaymentButtonPadding();
    observePaymentButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
